export function generatePdf(report: any, mode: string = "print"): Promise<Response> {
  const reportMode = mode === "download" ? "create" : "print";

  const payload = {
    dataSource: report,
    dataSourceVersion: null,
    format: null,
    localeName: "en",
    resultName: "order",
    templateName: "ParagonDiskWiper-Report",
    templateVersion: null,
    url: null
  };

  return fetch(`${process.env.REACT_APP_PDF_SERVICE_ENDPOINT}/templates/report/${reportMode}`, {
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    mode: "cors"
  });
}



// WEBPACK FOOTER //
// ./src/services/pdf.service.ts